export const ordinalAsLiteral = {
  1: 'first',
  2: 'second',
  3: 'third',
  4: 'fourth',
  5: 'fifth',
  6: 'sixth',
  7: 'seventh',
  8: 'eighth',
  9: 'ninth',
  10: 'tenth',
};
export const BEDDING_SIZE_NAME = 'bedding-size';
export const PILLOW_SIZE_NAME = 'pillow-size';
export const COLOR_NAME = 'color';
export const PILLOW_TYPE = 'pillows';
export const PILLOW_HEIGHT_NAME = 'pillow-height';
export const DEPTH_ATTRIBUTE_NAME = 'depth';

export const IGNORE_COLOR_PRODUCT_KEYS = [
  '7425736999101',
  'a6373a2b-6b25-44c6-baa3-f66e8bb4215e',
];

export const ATTRIBUTE_MAP = [
  {
    bundleProductProductTypeKey: 'sheet',
    targetAttribute: 'size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king', 'king-cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king', 'king-cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king', 'king-cal-king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king', 'king-cal-king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full', 'full-full-xl-queen'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full', 'full-full-xl-queen'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen', 'full-full-xl-queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen', 'full-full-xl-queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin', 'kids-twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin', 'kids-twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twin-xl', 'full'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twin-xl', 'full'],
      },
      {
        targetValue: 'twin/twin_xl',
        aovEquivalency: ['twin_xl', 'twin'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'duvet',
    targetAttribute: 'size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twin'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'pillows',
    targetAttribute: 'size',
    aovProductAttribute: 'pillow-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'cal_king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king/cal_king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'split_king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin_xl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin/twin_xl',
        aovEquivalency: ['standard'],
      },
    ],
    isVariantSuggestion: true,
  },
  {
    bundleProductProductTypeKey: 'mattress-protector',
    targetAttribute: 'size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full', 'fullxl'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full', 'fullxl'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen', 'fullxl'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen', 'fullxl'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'power-base',
    targetAttribute: 'size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'base',
    targetAttribute: 'size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'foundation',
    targetAttribute: 'size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'purple-pillow-case',
    targetAttribute: 'size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'travel_size',
        aovEquivalency: ['travel_size'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'purple-pillow-case',
    targetAttribute: 'size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'travel_size',
        aovEquivalency: ['travel_size'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'replacement-mattress-cover',
    targetAttribute: 'size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'sheet',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king', 'king-cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king', 'king-cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king', 'king-cal-king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king', 'king-cal-king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full', 'full-full-xl-queen'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full', 'full-full-xl-queen'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen', 'full-full-xl-queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen', 'full-full-xl-queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin', 'kids-twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin', 'kids-twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twin-xl', 'full'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twin-xl', 'full'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'duvet',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twin'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'pillows',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'pillow-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['standard'],
      },
    ],
    isVariantSuggestion: true,
  },
  {
    bundleProductProductTypeKey: 'bedding',
    targetAttribute: 'size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal_king',
        aovEquivalency: ['cal_king', 'king/cal_king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king/cal_king',
        aovEquivalency: ['cal_king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king', 'king/cal_king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full', 'fullxl'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full', 'fullxl'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen', 'fullxl'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen', 'fullxl'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin', 'twin/twin_xl'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twin_xl',
        aovEquivalency: ['twin_xl', 'twin/twin_xl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'twin/twin_xl',
        aovEquivalency: ['twin_xl', 'twin'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'power-base',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'base',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'foundation',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['sp-king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'purple-pillow-case',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'bedding-size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'travel_size',
        aovEquivalency: ['travel_size'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'replacement-mattress-cover',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'size',
    values: [
      {
        targetValue: 'cal-king',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'oop-calking-white',
        aovEquivalency: ['cal-king'],
      },
      {
        targetValue: 'sp-king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-splitking-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'king',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'oop-king-white',
        aovEquivalency: ['king'],
      },
      {
        targetValue: 'full',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'oop-full-white',
        aovEquivalency: ['full'],
      },
      {
        targetValue: 'queen',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'oop-queen-white',
        aovEquivalency: ['queen'],
      },
      {
        targetValue: 'twin',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'oop-twin-white',
        aovEquivalency: ['twin'],
      },
      {
        targetValue: 'twinxl',
        aovEquivalency: ['twinxl'],
      },
      {
        targetValue: 'oop-twinxl-white',
        aovEquivalency: ['twinxl'],
      },
    ],
  },
  {
    bundleProductProductTypeKey: 'duvet',
    targetAttribute: 'bedding-size',
    aovProductAttribute: 'pillow-size',
    values: [
      {
        targetValue: 'twin/twinxl',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'full/queen',
        aovEquivalency: ['standard'],
      },
      {
        targetValue: 'king/cal_king',
        aovEquivalency: ['king'],
      },
    ],
    isVariantSuggestion: true,
  },
];
